import React from 'react';
import Styled from 'styled';
import { Query } from '@apollo/client/react/components';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import LoadingProgress from 'lib/react-router/loading-progress';

import ErrorPage from 'four-nets/errors/error-page';
import VendorLatestAlbum from './vendor-latest-album/vendor-latest-album';

import query, { VendorAlbumsQuery } from './vendor-albums.graphql';
import defaultStyles from './vendor-albums.scss';

export interface Props {
    styles: typeof defaultStyles;
}

class VendorAlbums extends React.PureComponent<Props> {
    render() {
        const { styles } = this.props;

        return (
            <Query<VendorAlbumsQuery> query={query}>
                {({ loading, error, data }) => (
                    <LoadingProgress loading={loading}>
                        <ErrorPage error={error}>
                            {data && data.feed && data.feed.edges ? (
                                <div className={styles.wrapper}>
                                    <FormattedMessage id='NEWEST_VENDOR_ALBUMS'>
                                        {msg => <span className={styles.title}>{msg}</span>}
                                    </FormattedMessage>
                                    <div className={styles.albums}>
                                        {data.feed.edges.map(edge =>
                                            edge && edge.node ? (
                                                <div key={edge.node.id} className={styles.album}>
                                                    <VendorLatestAlbum {...edge.node} />
                                                </div>
                                            ) : null
                                        )}
                                    </div>
                                    <Link to='/blogs/professionals/' className={styles.button}>
                                        <FormattedMessage id='SHOW_ALL' />
                                    </Link>
                                </div>
                            ) : null}
                        </ErrorPage>
                    </LoadingProgress>
                )}
            </Query>
        );
    }
}

export default Styled(defaultStyles)(VendorAlbums);
